export const BACKGROUND_COLOR_CHANGE_ON_HOVER = false;

export const CONFIRM_DELETE_PAYMENT_METHOD_ID = 'confirmDeletePaymentMethod';
